module.exports = __webpack_public_path__ + "h5/img/loading.04c32310.gif";